<template>
  <ToastModal
    ref="modal"
    :title="$t('Navbar.CountryLanguageModal.Title')"
    show-mobile-footer
    class="disable-scrollbars"
    modal-id="CountryLocaleToastModal"
  >
    <div class="pt-3 disable-scrollbars">
      <div class="mb-6">
        <OSelect
          class="select-country"
          :label="$t('Navbar.CountryLanguageModal.SelectCountry')"
          :value="selectedCountryOption"
          :options="countryOptions"
          svg="new-chevron-right"
          svg-classes="rounded w-2"
          :clearable="false"
          :disabled="disableCountry"
          @input="selectedCountry = $event.value"
        />
      </div>
      <div>
        <OSelect
          class="select-country"
          :label="$t('Navbar.CountryLanguageModal.SelectLanguage')"
          :value="selectedLanguageOption"
          :options="languageOptions"
          svg="new-chevron-right"
          svg-classes="rounded w-2"
          :clearable="false"
          @input="selectedLocale = $event.value"
        />
      </div>
    </div>
    <template v-slot:footer>
      <ToastModalFooter
        :text="$t('Navbar.CountryLanguageModal.Confirm')"
        variant="solid"
        color="blue"
        @click="onSubmit"
      />
    </template>
  </ToastModal>
</template>

<script>
import ToastModal from '@/components/ToastModal'
import OSelect from '@/components/OSelect'
import ToastModalFooter from '@/components/ToastModal/ToastModalFooter'
import { CountryCodes, LocaleIcons, LocaleNames, Locales } from '@/enums/general'
import { defaultState } from '@/enums/signup'
import { SET_SIGNUP_STATE } from '@/utils/store/mutationTypes'
import { mapMutations } from 'vuex'
import { CCOUNTRY, CLOCALE } from '@/utils/cookie/cookieTypes'
import { getCookieDomain } from '@/utils/cookie'
import cookieConfig from '@/config/cookie'

export default {
  name: 'CountryLocaleToastModal',
  components: { ToastModal, OSelect, ToastModalFooter },
  props: {
    disableCountry: {
      type: Boolean,
      default: false
    },
    country: {
      type: String,
      default: CountryCodes.netherlands
    },
    locale: {
      type: String,
      default: Locales.nl
    },
    countryOptions: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      selectedLocale: this.locale,
      selectedCountry: this.country
    }
  },
  computed: {
    selectedCountryOption () {
      return {
        svg: this.selectedCountry,
        label: this.$t(`Countries.${this.selectedCountry}`),
        value: this.selectedCountry
      }
    },
    selectedLanguageOption () {
      return {
        svg: LocaleIcons[this.selectedLocale],
        label: LocaleNames[this.selectedLocale],
        value: this.selectedLocale
      }
    },
    languageOptions () {
      return Object.keys(Locales).map(key => ({
        svg: LocaleIcons[key],
        label: LocaleNames[key],
        value: Locales[key]
      }))
    }
  },
  watch: {
    selectedLocale (newLocale) {
      if (newLocale !== this.selectedLocale) {
        this.selectedLocale = newLocale
      }
    },
    selectedCountry (newCountry) {
      if (newCountry !== this.selectedCountry) {
        this.selectedCountry = newCountry
      }
    }
  },
  methods: {
    toggleActivation () {
      this.$refs.modal.toggleActivation()
    },
    onModalClose () {
      this.$refs.modal.onModalClose()
    },
    onSubmit () {
      this.setSignupState(defaultState)
      this.$i18n.switchLocalePath(this.selectedLocale, this.selectedCountry)
      this.$moment.locale(this.selectedLocale)
      this.$cookies.set(CLOCALE, this.selectedLocale, {
        path: '/',
        maxAge: cookieConfig.maxAge,
        domain: getCookieDomain()
      })
      this.$cookies.set(CCOUNTRY, this.selectedCountry, {
        path: '/',
        maxAge: cookieConfig.maxAge,
        domain: getCookieDomain()
      })
      this.onModalClose()
    },
    ...mapMutations('signup', {
      setSignupState: SET_SIGNUP_STATE
    })
  }
}
</script>

<style scoped lang="postcss">
>>> svg.w-2.text-black {
  @apply w-2 !important;
}

>>> .vs__dropdown-toggle {
  @apply border-none px-0 !important;
}

>>> .toast-modal-button-blue {
  @apply bg-newBlue-400 rounded-full text-neutral-00 py-2;
}

>>> {
  .vs__selected, .vs__selected-options {
    @apply ml-0 pl-0 !important;
  }
}
</style>
